import { LatLngUtils } from '../map/lat-lng-utils'
import { To } from '~/utils/remix-router-types'
import { VehicleType } from '../vehicle-types/vehicle-types'
import { ProductAdventureTypeFilter, ProductNumberOfSeatsFilter } from './product-query.server'

interface getLinkToSearchPageOptions {
  place: string | null
  mapBounds: {
    sw_lat: number
    sw_lng: number
    ne_lat: number
    ne_lng: number
  } | null
  view?: 'map' | 'list'
  tag: string | null
  additionalTag: string | null
  vehicle: VehicleType | null
  numberOfSeats: ProductNumberOfSeatsFilter | null
  adventureType: ProductAdventureTypeFilter | null
  /**
   * this navigation is about to be replaced by another navigation.
   * This is used to show search results slightly sooner. This should
   * almost always be false
   */
  transition: boolean
}

export function getLinkToSearchPage(options: getLinkToSearchPageOptions): To & { toString(): string } {
  const to: To = {
    pathname: '/search',
    search: getSearchParamsForProductSearch(options).toString()
  }
  return {
    ...to,
    toString() {
      return `${to.pathname}?${to.search}${to.hash ? `#${to.hash}` : ''}`
    }
  }
}

export function getSearchParamsForProductSearch({
  place,
  mapBounds,
  view = 'list',
  tag,
  numberOfSeats,
  additionalTag,
  vehicle,
  transition,
  adventureType
}: getLinkToSearchPageOptions) {
  const searchParams = new URLSearchParams()
  searchParams.append('view', view)
  if (tag) searchParams.append('tag', tag)
  if (additionalTag) searchParams.append('additionalTag', additionalTag)

  if (vehicle) searchParams.append('vehicle', vehicle)
  if (place) searchParams.append('place', place)
  if (numberOfSeats) searchParams.append('seats', numberOfSeats)
  if (adventureType) searchParams.append('adventureType', adventureType)
  if (transition) searchParams.append('transition', 'true')

  if (mapBounds) {
    /**
     * Quantize bounds to the 0.001° grid (~110m at equator), always expanding outward
     * so the query box never excludes a pin that is visible in the viewport.
     * NE bounds ceil (north/east), SW bounds floor (south/west).
     */
    const q = LatLngUtils.quantizeBoundsExpanding(mapBounds)
    searchParams.append('ne_lat', q.ne_lat)
    searchParams.append('ne_lng', q.ne_lng)
    searchParams.append('sw_lat', q.sw_lat)
    searchParams.append('sw_lng', q.sw_lng)
  }
  return searchParams
}
